import { extendYup } from "@gymflow/common";
import { ReactNode, useEffect, useState } from "react";
import * as Yup from "yup";

import { LoadingPortal } from "../components/pages";
import { useClubSettings } from "./settings";

export function YupExtensions({ children }: { children: ReactNode }) {
  const { properties } = useClubSettings();
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    if (properties.dateFormat) {
      extendYup(Yup, properties.dateFormat);
      setIsLoaded(true);
    }
  }, [properties.dateFormat]);

  if (!isLoaded) {
    return <LoadingPortal message="Processing form settings..." />;
  }
  return children;
}
